import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { formatCommaZeroDp, formatCommaXDp } from "./dataHelpers/formatters";

// COLORS

export const COLOR_SCHEME = "#3CD0CF,#41ADBD,#488CA4,#4A6C87".split(",");
export const COLORS = {
  chartRefArea1: "#faf8f8",
  chartRefArea2: "#9e9e9e",
  chartRefLine: "#635F5D",
  chartPrimary: "#6BAED6",
  chartSecondary: "#C6DBEF",
  chartNoData: "#e5e5e5",
};

// SCALE

const SCALE_DAYS_OPTIONS = {
  colorSteps: 4,
  filterVals: (val) => val > 0, // exclude negatives from scale
  bumpColorStep: true,
};

const SCALE_TIME_OPTIONS = {
  colorSteps: 4,
  bumpColorStep: true,
};

export const SCALE_OPTIONS = {
  avgNdwDays: SCALE_DAYS_OPTIONS,
  avgTotalDaysWithNoEvents: SCALE_DAYS_OPTIONS,
  avgDaysWithOnlyEventsBefore1Pm: SCALE_TIME_OPTIONS,
  avgPercDaysWithOnlyEventsBefore1Pm: SCALE_TIME_OPTIONS,
};

// LEGEND

const LEGEND_PTO = {
  title: "Avg. days without case events",
  valFormatter: (x) => formatCommaZeroDp(x),
};

const LEGEND_DAYS_WITH_EVENTS = {
  title: "Avg. days with no events",
  valFormatter: (x) => formatCommaZeroDp(x),
};

const LEGEND_TIME = {
  title: "Avg. afternoons without case events",
  valFormatter: (x) => formatCommaZeroDp(x),
};

const LEGEND_TIME_PERC = {
  title: "Perc. of days with no afternoon work",
  valFormatter: (x) => `${formatCommaXDp(x * 100, 0)}%`,
};

export const LEGEND_OPTIONS = {
  avgNdwDays: LEGEND_PTO,
  avgTotalDaysWithNoEvents: LEGEND_DAYS_WITH_EVENTS,
  avgDaysWithOnlyEventsBefore1Pm: LEGEND_TIME,
  avgPercDaysWithOnlyEventsBefore1Pm: LEGEND_TIME_PERC,
};

// MAP
export const PANEL_SIDEVIEW_BREAKPOINT = 600;
export const DEFAULT_BBOX_PADDING = {
  top: 20,
  left: 20,
  right: 20,
  bottom: 20,
};

export const DEFAULT_BBOX_PADDING_SIDEPANEL = {
  top: 20,
  left: 20,
  right: 20,
  bottom: 20,
};

export const MAP_PADDING_RATIO_MOBILE_BOTTOM = 0.75;
export const MAP_PADDING_RATIO_MOBILE_TOP = 0.05;
export const MAP_KEY_OPTIONS = [
  {
    value: "avgNdwDays",
    label: "Days",
  },
  {
    value: "avgDaysWithOnlyEventsBefore1Pm",
    label: "Afternoons",
  },
];

// JUDGE LIST
export const JUDGES_PER_PAGE_BREAKPOINT = 350;
export const JUDGE_LIST_OPTIONS = {
  avgNdwDays: {
    accessor: "ndwDays",
    header: "Days without case events",
    sortDesc: true,
    sortType: "basic",
  },
  avgDaysWithOnlyEventsBefore1Pm: {
    accessor: "daysWithOnlyEventsBefore1Pm",
    header: "Days with no afternoon proceedings",
    sortDesc: true,
    sortType: "basic",
  },
};

// YEAR

export const YEAR_OPTIONS = [
  { value: 2018, label: 2018 },
  { value: 2019, label: 2019 },
];

// BUTTON SCHEMAS
export const YEAR_BUTTON_SCHEMA = [
  { id: 2018, label: 2018 },
  { id: 2019, label: 2019 },
];

export const JUDGE_BUTTON_SCHEMA = [
  { id: "days", label: "days", icon: faCalendarAlt },
  { id: "time", label: "afternoons", icon: faClock },
];

export const COUNTY_BUTTON_SCHEMA = [
  { id: "overview", label: "overview" },
  { id: "judges", label: "judges" },
];

export const LEGEND_COLOR_BUTTON_SCHEMA = [
  { id: "avgNdwDays", label: "Days" },
  { id: "avgDaysWithOnlyEventsBefore1Pm", label: "Afternoons" },
];

// INITITAL OR DEFAULT
export const DEFAULT_PANEL_SML_SCREEN_MIN_HEIGHT = 294; // ! This is also set in CSS stylesheet
export const INITIAL_YEAR_OPTION = YEAR_OPTIONS[1];
export const INITIAL_MAP_KEY_OPTION = MAP_KEY_OPTIONS[0];

export const DEFAULT_SELECTION = {
  id: undefined,
  type: "",
  county: "",
  label: "",
};

// NOTES
export const MISSING_COUNTIES = [
  {
    id: "Luzerne",
    note:
      "Luzerne county judges have been have been excluded due to data accuracy concerns.",
  },
  {
    id: "Philadelphia",
    note:
      "Philadelphia has been excluded because it does not have magisterial district court judges and uses different processes for managing cases.",
  },
];

export const COUNTY_DATA_NOTES = {
  Allegheny:
    "Pittsburgh judges have been excluded due to concerns about data accuracy.",
};

// DEV CONSTANTS
// Used for testing functionality.
export const DUMMY_SELECTION_HANIF = {
  id: "ID_338",
  type: "judge",
  county: "Dauphin",
  label: "Hanif Johnson (Dummy)",
};

export const DUMMY_SELECTION_POTTER = {
  id: "Potter",
  type: "county",
  county: "Potter",
  label: "Potter",
};
